import { useEffect, useState } from 'react'

export const useValidationMessages = () => {
    const [ValidationMessages, setMessages] = useState({
        required: '',
        noLeadingSpaces: '',
        password: {
            required: '',
            placeholder: '',
            match: ''
        },
        email: {
            required: '',
            invalid: '',
            placeholder: ''
        },
        confirmPassword: { required: '', placeholder: '' },
        name: { required: '', placeholder: '' },
        fname: { required: '', placeholder: '' },
        lname: { required: '', placeholder: '' },
        currentPassword: {
            required: '',
            placeholder: ''
        },
        linkedin_cookie: {
            'required': '',
            'placeholder': ''
        },
        title: { required: '', placeholder: '' },
        sub_title: { required: '', placeholder: '' },
        interval: { required: '', placeholder: '' },
        amount: { required: '', placeholder: '', invalid: '' },
        price_id: { required: '', placeholder: '' },
        seq: { required: '', placeholder: '' },
        threshold_score: { required: '', placeholder: '', invalid: '' },
        type: { required: '', placeholder: '' },
        number_of_scans: { required: '', placeholder: '', invalid: '' },
        linkedIn_score: { required: '', placeholder: '', invalid: '' },
        free_trial_scans: { required: '', placeholder: '', invalid: '' },
        number_of_days: { required: '', placeholder: '', invalid: '' }
    })
    useEffect(() => {
        setMessages({
            required: 'This field is required',
            noLeadingSpaces: 'Blank spaces are not allowed.',
            password: {
                required: 'Password is required',
                placeholder: 'Enter your password',
                match: 'Passwords and confirm password should be same'
            },
            email: {
                required: 'Email is required',
                invalid: 'Please enter a valid email address',
                placeholder: 'Enter your email'
            },
            confirmPassword: {
                required: 'Please confirm your password',
                placeholder: 'Confirm your password'
            },
            name: {
                required: 'Name is required',
                placeholder: 'Enter your name'
            },
            fname: {
                required: 'First name is required',
                placeholder: 'Enter your first name'
            },
            lname: {
                required: 'Last name is required',
                placeholder: 'Enter your last name'
            },
            currentPassword: {
                'required': 'Current password is required',
                'placeholder': 'Enter your current password'
            },
            linkedin_cookie: {
                'required': 'linkedin cookie is required!',
                'placeholder': `[
                {
                    "domain": ".linkedin.com",
                    "expirationDate": 1749646309.906783,
                    "hostOnly": false,
                    "httpOnly": false,
                    "name": "lms_ads",
                    "path": "/",
                    "sameSite": "no_restriction",
                    "secure": true,
                    "session": false,
                    "storeId": null,
                    "value": ""
                },...
]
                `
            },
            title: {
                required: 'Title is required',
                placeholder: 'e.g. Monthly'
            },
            sub_title: {
                required: 'Sub title is required',
                placeholder: 'e.g. Starter package for new users'
            },
            amount: {
                required: 'Amount is required',
                placeholder: 'e.g. 299',
                invalid: 'Please enter a valid amount'
            },
            price_id: {
                required: 'Price is required',
                placeholder: 'Enter stripe price id'
            },
            seq: {
                required: 'Display order is required',
                placeholder: 'e.g. 1'
            },
            interval: {
                required: 'Interval is required',
                placeholder: 'Select interval'
            },
            threshold_score: {
                required: 'Threshold Score is required',
                placeholder: 'e.g. 70',
                invalid: 'Please enter a valid threshold score'
            },
            type: {
                required: 'Type is required',
                placeholder: 'Select type'
            },
            number_of_scans: {
                required: 'Number of scans is required',
                placeholder: 'e.g. 10',
                invalid: 'Please enter a valid number of scans'
            },
            linkedIn_score: {
                required: 'LinkedIn Score is required',
                placeholder: 'e.g. 80',
                invalid: 'Please enter a valid LinkedIn score'
            },
            free_trial_scans: {
                required: 'Daily scans is required',
                placeholder: 'e.g. 5',
                invalid: 'Please enter a valid number of daily scans'
            },
            number_of_days: {
                required: 'Trial duration is required',
                placeholder: 'e.g. 7',
                invalid: 'Please enter a valid trial duration'
            }
        })
    }, [])
    return ValidationMessages
}
